<template>
  <v-card class="card-container">
    <v-dialog v-model="addModal" max-width="500" persistent>
      <Manage
        :engType="activeEngType"
        @close=";(addKey = !addKey), (addModal = false)"
        @confirm="onVideoAdded"
        :key="addKey"
      />
    </v-dialog>

    <div class="main-toolbar">
      <div class="icon-back">
        <v-icon id="icon" size="37" color="white"> mdi-video </v-icon>
      </div>

      <span class="main-toolbar-title">Vídeos</span>

      <v-spacer></v-spacer>

      <v-btn
        depressed
        dark
        class="mr-2 hidden-sm-and-down secondary-button"
        @click=";(addKey = !addKey), (addModal = true)"
        v-if="user.mainType == 0"
      >
        {{ $t('Adicionar') }}
      </v-btn>
    </div>

    <v-tabs
      color="secondary"
      v-model="tab"
      :height="40"
      grow
      :mobile-break-point="300"
      class="ma-3"
    >
      <v-tabs-slider color="#BBCF20"></v-tabs-slider>
      <v-tab
        v-if="showClinicTab || user.mainType == 0 || user.mainType == 1"
        active-class="activated-tab"
        class="rounded-lg rounded-b-0"
      >
        <v-icon class="mr-2">mdi-video</v-icon>
        {{ $t('Engenharia clinica') }}
      </v-tab>
      <v-tab
        v-if="showInfraTab || user.mainType == 0 || user.mainType == 1"
        active-class="activated-tab"
        class="rounded-lg rounded-b-0"
      >
        <v-icon class="mr-2">mdi-video</v-icon>
        {{ $t('Engenharia de infraestrutura') }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item v-if="showClinicTab || user.mainType < 2">
        <VideoList :engType="0" :user="user" ref="clinic" />
      </v-tab-item>
      <v-tab-item v-if="showInfraTab || user.mainType < 2">
        <VideoList :engType="1" :user="user" ref="infra" />
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import ApiService from '../../../services/ApiService'
import Manage from './components/manage.vue'
import VideoList from './components/VideoList.vue'

export default {
  name: 'VideosPage',

  components: {
    Manage,
    VideoList,
  },

  data() {
    return {
      user: {},
      addKey: false,
      addModal: false,
      tab: 0,
      apiService: new ApiService(),
      institution: {},
    }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
  },

  computed: {
    showClinicTab() {
      const types = this.institution?.departmentTypes || []
      return this.institution?.showVideos && types.includes(0)
    },
    showInfraTab() {
      const types = this.institution?.departmentTypes || []
      return this.institution?.showVideos && types.includes(1)
    },
    activeEngType() {
      const clinicTabVisible = this.showClinicTab || this.user.mainType < 2
      if (!clinicTabVisible) return 1
      return this.tab === 0 ? 0 : 1
    },
  },

  methods: {
    onVideoAdded() {
      this.addKey = !this.addKey
      this.addModal = false
      const clinicFirst = this.showClinicTab || this.user.mainType < 2
      const ref = clinicFirst && this.tab === 0 ? this.$refs.clinic : this.$refs.infra
      ref?.loadData?.()
    },
  },

  watch: {
    tab() {
      const clinicFirst = this.showClinicTab || this.user.mainType < 2
      const ref = clinicFirst && this.tab === 0 ? this.$refs.clinic : this.$refs.infra
      ref?.loadData?.()
    },
  },
}
</script>
